import generatePoints from "../../../../../../../src/utils/generator/generatePoints";
import { normalizeRadian } from "../../../../../../../src/utils/math/normalizeRadian";
import DancePointsAnim from "../../../animations/DancePointsAnimation";
import AngleBg from "../../../entities/AngleBg";
import { CIRCLE_RADIUS } from "../../../types/Config";
import PointManager from "../../PointManager";
import AngleManager from "../../AngleManager";
import LineManager from "../../LineManager";
import Circle from "../../../../../../../src/entities/Circle";


const bRadian = Math.PI / 10;
const radiansListArr = [
  [
    [(-Math.PI / 20) * 1.6, -Math.PI / 20 * 1.2, -Math.PI / 6],
    [Math.PI / 6 * 1.5, (Math.PI / 6) * 2, Math.PI / 1.8],
    [Math.PI / 20, -Math.PI / 15, -Math.PI / 1.7],
  ],
  [
    [-Math.PI / 9, Math.PI / 9, -Math.PI / 6],
    [Math.PI / 2.25, Math.PI / 4, Math.PI / 2],
    [Math.PI / 6, -Math.PI / 6, -Math.PI / 2],
  ]
]


export async function drawMovePoints(AngleBgArr: AngleBg[], circle: Circle, PointManager: PointManager, AngleManager: AngleManager, LineManager: LineManager): Promise<void> {
  const radiansList = radiansListArr[AngleBgArr.length - 1]
  const refAngles = PointManager.getInitialRadians();
  const handleUpdate = (radians: number[], offsetAngles: number[]) => {
    danceElements(AngleBgArr, circle, PointManager, AngleManager, LineManager,
      refAngles.map((rAngle, rI) => rAngle + offsetAngles[rI]), radians)
  }


  const calcPrevArray = (index: number) => {
    return radiansList.reduce((total, curr, currIndex) => {
      const t = [total[0] + curr[0], total[1] + curr[1], total[2] + curr[2]]
      return index > currIndex ? t : total;
    }, [0, 0, 0])
  }
  const calcDuration = (index: number) => Math.floor(Math.abs(radiansList[index][2] / bRadian) * 200)
  const lastPosition = calcPrevArray(radiansList.length).map(r => -r)
  const lastDuration = Math.floor(Math.abs(lastPosition[2] / bRadian) * 400)

  await movePoints(radiansList[0], calcDuration(0), r => handleUpdate(r, [0, 0, 0]));
  await movePoints(radiansList[1], calcDuration(1), r => handleUpdate(r, calcPrevArray(1)));
  await movePoints(radiansList[2], calcDuration(2), r => handleUpdate(r, calcPrevArray(2)));
  await movePoints(lastPosition, lastDuration, r => handleUpdate(r, calcPrevArray(radiansList.length)));
}


const movePoints = (tRadians: number[], duration: number, handleUpdate: (r: number[], offset: number) => void): Promise<void> => {
  return new Promise((resolve) => {
    new DancePointsAnim(tRadians, duration, r => handleUpdate(r, 0), resolve, resolve)
  })
}


function danceElements(AngleBgArr: AngleBg[], circle: Circle, PointManager: PointManager, AngleManager: AngleManager, LineManager: LineManager, refAngles: number[], offsetAngles: number[]) {
  const getRadian = (index: number) => normalizeRadian(refAngles[index] + offsetAngles[index]);
  const PointRadians: number[] = PointManager.getRedPoints().map((rP, rPI) => getRadian(rPI))
  const centerPoint = PointManager.getPoints()[0];
  const points = generatePoints(centerPoint, PointRadians, CIRCLE_RADIUS);
  const startPointArr = [points[2], centerPoint]
  LineManager.rLine1CirSide1.draw(points[0], points[2]);
  LineManager.lLine1CirSide2.draw(points[1], points[2]);
  if (AngleBgArr.length > 1) {
    LineManager.lLine2CenSide1.draw(centerPoint, points[0]);
    LineManager.rLine2CenSide2.draw(centerPoint, points[1]);

  }

  AngleManager.draw([centerPoint, ...points], false);
  AngleManager.circumAngle.AngleValue.setValue("x");
  AngleManager.centerAngle.AngleValue.setValue("2x");

  AngleBgArr.forEach((AngleBg, aI) => AngleBg.draw(PointRadians[1], PointRadians[0], startPointArr[aI]));

  circle.draw({
    radians: PointRadians.sort((a, b) => a - b),
    radius: circle.radius
  })
}
